/**
 * お問い合わせページ専用の処理
 */

export default class Contact {
  constructor(_parm) {
  }

  /**
   * パラメータに`?lineup=nihon-noie-project`のように付いていたら、該当する商品にチェックを入れる
   */
  setCheckedLineup() {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const parmaLineup = params.get('lineup') ? params.get('lineup').trim() : false;
    if (!parmaLineup) return;
    const elmLineupCheckboxWrap = document.querySelector('#js-lineup-checkbox-wrap');
    const arrayElmsLineupCheckbox = [...elmLineupCheckboxWrap.querySelectorAll('input[type="checkbox"]')];
    arrayElmsLineupCheckbox.forEach(_elmCheckbox => {
      // WPプラグインで追加したチェックボックスのvalueの最後に謎の半角スペースが入る時があるから、trim()で削除
      const value = _elmCheckbox.value.trim();
      if (parmaLineup.match(value)) {
        _elmCheckbox.checked = true;
      }
    });
  }

  init() {
    this.setCheckedLineup();
  }

}